/* Foxpop behaviour layer for BALMiso.
   One file, loaded once from theme.liquid, so future behaviour does not need
   another edit to a G5 file. Everything here is opt-in through a class the
   section carries, so a section without the class is untouched. */
(function () {
  'use strict';

  /* --- Ritual cards: lift the one under the cursor -------------------------
     CSS :hover already does this on the live site. It cannot do it inside the
     Shopify theme editor: the editor lays its own section-selection surface
     over the page to catch clicks, so the pointer never reaches the card and
     :hover never fires. Since the editor is where this gets reviewed, the state
     is driven from pointer events as well, which the editor does not intercept.

     pointerover/pointerout are used rather than pointerenter/leave because only
     the former bubble, so one delegated listener survives the section being
     re-rendered as settings change in the editor. */
  var SECTION = '.balmiso-card-overlay';
  var CARD = '.gsp-collection-card';
  var LIT = 'is-lit';

  // same gate as the stylesheet: desktop with a real cursor. A touch screen has
  // no hover, so the cards would sit dulled with no way to bring them back.
  var desktop = window.matchMedia('(min-width: 992px) and (hover: hover)');

  function clear(section) {
    var lit = section.querySelectorAll(CARD + '.' + LIT);
    for (var i = 0; i < lit.length; i++) lit[i].classList.remove(LIT);
  }

  document.addEventListener('pointerover', function (e) {
    if (!desktop.matches) return;
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var section = t.closest(SECTION);
    if (!section) return;
    var card = t.closest(CARD);
    clear(section);
    if (card) card.classList.add(LIT);
  }, true);

  document.addEventListener('pointerout', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var section = t.closest(SECTION);
    if (!section) return;
    // only clear when the pointer has actually left the section, not when it
    // crosses between two children inside it
    if (!section.contains(e.relatedTarget)) clear(section);
  }, true);

  /* --- Video: drop the browser's own control bar -------------------------
     featured-media.liquid and video.liquid both call el__video with
     `controls: true` hardcoded. The snippet's own default is false, so this is
     the section overriding it, and there is no setting in the schema that turns
     it back off. That is why the scrubber, timer, mute and kebab appear on a
     brand film and nothing in the editor removes them.

     Handled here rather than by editing the section, so it survives a theme
     update and does not add more vendor surface.

     Only the control bar goes. Autoplay and looping stay with the section's own
     checkboxes, and the theme's styled play button is left alone, so the film is
     still startable once the native bar is gone.

     Opt in with `balmiso-video-clean` in the section's custom class. */
  function cleanVideos(root) {
    var scopes = (root || document).querySelectorAll('.balmiso-video-clean');
    for (var i = 0; i < scopes.length; i++) {
      var vids = scopes[i].querySelectorAll('video[controls]');
      for (var j = 0; j < vids.length; j++) {
        vids[j].removeAttribute('controls');
        vids[j].controls = false;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { cleanVideos(); });
  } else {
    cleanVideos();
  }

  // the editor rebuilds a section on every settings change, which restores the
  // attribute; this is the event Shopify fires when that happens
  document.addEventListener('shopify:section:load', function (e) { cleanVideos(e.target); });

  /* The section injects its video only when it scrolls into view, well after
     DOMContentLoaded, so a one-off pass misses it. loadstart fires on every
     video the moment it starts fetching, including one inserted later. It does
     not bubble, but a capture-phase listener on document still sees it, since
     capture runs from the root down to the target. */
  document.addEventListener('loadstart', function (e) {
    var v = e.target;
    if (!v || v.tagName !== 'VIDEO' || !v.hasAttribute('controls')) return;
    if (typeof v.closest !== 'function' || !v.closest('.balmiso-video-clean')) return;
    v.removeAttribute('controls');
    v.controls = false;
  }, true);

  /* --- Decorative video: never a control bar -------------------------------
     The hero background and the hero card run muted, looping and silent. They
     are artwork, not a player.

     iOS refuses to autoplay them on a cold load: always in Low Power Mode, and
     often on a first visit before the page has any user activation. Purevea's
     video-element catches that rejection and does this, in theme.js:

         target.play().catch((error) => {
           if (error.name === "NotAllowedError") {
             this.setAttribute("suspended", "");
             target.controls = true;

     ...which drops the full native player -- scrubber, AirPlay, PiP, skip
     buttons -- straight over the artwork. That is the control bar on the phone,
     and it is also why arriving from another page looks fine: by then the tap
     that brought you here counts as activation, autoplay succeeds, and the
     catch never runs.

     A user-initiated play() is permitted even in Low Power Mode, so the first
     real tap is enough to start them. Until that happens the frame simply sits
     still, which is what the design wants anyway. Scroll is deliberately not
     used as the trigger: Safari does not count it as activation, so calling
     play() on scroll would fail and re-arm the theme's controls fallback. */
  var DECOR_SCOPE = '.balmiso-hero-video, .balmiso-video-clean, .gsp-hero-video';

  function decorVideos(root) {
    var out = [], scopes = (root || document).querySelectorAll(DECOR_SCOPE);
    for (var i = 0; i < scopes.length; i++) {
      var v = scopes[i].querySelectorAll('video');
      for (var j = 0; j < v.length; j++) out.push(v[j]);
    }
    return out;
  }

  function undressVideo(v) {
    if (v.controls || v.hasAttribute('controls')) {
      v.removeAttribute('controls');
      v.controls = false;
    }
    var host = typeof v.closest === 'function' ? v.closest('video-element') : null;
    if (host && host.hasAttribute('suspended')) host.removeAttribute('suspended');
  }

  function wakeDecorVideos() {
    var vids = decorVideos();
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      undressVideo(v);
      if (!v.paused) continue;
      var host = v.closest('video-element') || v;
      // Only the video on screen. Videos off screen are paused on purpose by the
      // visibility rule at the end of this file; waking them on every tap is
      // what kept them playing in the background.
      if (host.dataset.balmisoInView !== '1') continue;
      if (host !== v) {
        // A theme player owns its own mute state: its icon reads the `muted`
        // attribute on <video-element>. Forcing the native video muted here
        // split the two, so the icon said sound was on while the video was
        // silent. Leave muted alone and tell the player it is running.
        host.paused = false;
      } else if (v.dataset.balmisoSound !== '1') {
        // muted is what makes the retry legal, unless the visitor has already
        // chosen sound: then this tap itself makes an audible play() legal.
        v.muted = true;
      }
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  // the theme sets .controls as a property after the rejection, which still
  // reflects to the attribute, so watching attributes catches it
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.tagName === 'VIDEO' && typeof t.closest === 'function' && t.closest(DECOR_SCOPE)) {
          undressVideo(t);
        }
      }
    }).observe(document.documentElement, {
      subtree: true, attributes: true, attributeFilter: ['controls']
    });
  }

  var GESTURES = ['pointerdown', 'touchend', 'click', 'keydown'];
  for (var g = 0; g < GESTURES.length; g++) {
    document.addEventListener(GESTURES[g], wakeDecorVideos, { capture: true, passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wakeDecorVideos(); });
  } else {
    wakeDecorVideos();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var vids = decorVideos(e.target);
    for (var i = 0; i < vids.length; i++) undressVideo(vids[i]);
  });

  /* --- Carousel dots for the phone card track -------------------------------
     The track itself is native scroll-snap and needs no JavaScript. This only
     adds the position indicator, because a horizontal strip with one card
     showing gives no sense of how many there are or where you are in them.
     Built once per section, kept in sync from the scroll position, and each dot
     scrolls to its card. Everything is delegated off the track element, so a
     section re-render in the theme editor rebuilds cleanly. */
  var SWIPE = '.balmiso-cards-swipe';

  /* Native smooth scrolling is cancelled on a scroll-snap container: verified
     both scrollTo({behavior:'smooth'}) and CSS scroll-behavior leaving
     scrollLeft at 0, under mandatory and proximity alike, while a plain
     assignment moved it. So the tween is done by hand. Swiping on a phone is
     native and never touches this; it is only for the dots. */
  function glide(el, to) {
    var from = el.scrollLeft, delta = to - from, start = null, ms = 380;
    if (Math.abs(delta) < 2) return;
    function step(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / ms);
      var eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;   // easeInOutQuad
      el.scrollLeft = from + delta * eased;
      if (t < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);

    /* requestAnimationFrame is suspended whenever the document is hidden, and
       some embedded viewers keep it that way permanently. Confirmed here: a
       setTimeout fired while an rAF callback never did. Without this the dot
       would look dead. If the tween has not arrived by the time it should
       have, the position is set outright, so the dot always works. */
    window.setTimeout(function () {
      if (Math.abs(el.scrollLeft - to) > 2) el.scrollLeft = to;
    }, ms + 80);
  }

  function buildDots(section) {
    var track = section.querySelector('.scrolling-cards-inner');
    if (!track || track.dataset.balmisoDots) return;
    var cards = track.querySelectorAll('.gsp-scrolling-cards-item');
    if (cards.length < 2) return;
    track.dataset.balmisoDots = '1';

    var dots = document.createElement('div');
    dots.className = 'balmiso-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Product');

    for (var i = 0; i < cards.length; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'balmiso-dots__dot';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.dataset.index = i;
      dots.appendChild(b);
    }
    track.parentNode.insertBefore(dots, track.nextSibling);

    function nearest() {
      // the card whose centre is closest to the track's centre
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    /* rAF is the right throttle for a scroll handler, but it never fires while
       the document is hidden, which would leave the active dot stale. Falls
       back to a timer so the indicator always tracks the track. */
    var raf = function (fn) {
      if (document.visibilityState === 'visible' && window.requestAnimationFrame) {
        window.requestAnimationFrame(fn);
      } else {
        window.setTimeout(fn, 16);
      }
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      raf(function () {
        var active = nearest();
        var all = dots.children;
        for (var i = 0; i < all.length; i++) {
          all[i].setAttribute('aria-current', i === active ? 'true' : 'false');
        }
        ticking = false;
      });
    }, { passive: true });

    dots.addEventListener('click', function (e) {
      var dot = e.target.closest('.balmiso-dots__dot');
      if (!dot) return;
      var card = cards[dot.dataset.index | 0];
      if (!card) return;
      glide(track, card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2);
    });
  }

  function initDots(root) {
    var secs = (root || document).querySelectorAll(SWIPE);
    for (var i = 0; i < secs.length; i++) buildDots(secs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initDots(); });
  } else {
    initDots();
  }
  document.addEventListener('shopify:section:load', function (e) { initDots(e.target); });

  /* --- Scent index: an accordion on phones ----------------------------------
     Two columns on desktop: a panel of six figures beside a list of six names.
     Stacked on a phone that leaves the picture 181px above the list and the
     section 1068px tall on an 812px screen, so by the time you reach the names
     the thing you are switching has scrolled away.

     Each figure moves to sit directly AFTER its own name. Not inside it: the
     names are <button> elements, and a button sizes to its content's
     max-content width, so a figure nested in one inflated the row to the
     image's natural 928px and pushed the whole grid off the screen. It is also
     invalid nesting. As a sibling in the same one-column grid it lands in the
     same place visually with none of that.

     Which mode to use is read from the stylesheet rather than measured here.
     window.innerWidth and matchMedia can both disagree with what the CSS is
     actually doing (an embedded viewer reported 375 while laying out at 1030),
     and when they disagreed the figures moved while the accordion CSS never
     applied. The media query sets --balmiso-accordion and this reads it back,
     so the two cannot come apart.
     -------------------------------------------------------------------------- */
  var ING_WRAP = '[data-balmiso-ing]';

  function ingWantsAccordion(wrap) {
    return getComputedStyle(wrap).getPropertyValue('--balmiso-accordion').trim() === '1';
  }

  function ingToAccordion(wrap) {
    if (wrap.dataset.balmisoAccordion === '1') return;
    var items = wrap.querySelectorAll('.balmiso-ing__item');
    var figs = wrap.querySelectorAll('.balmiso-ing__figure');
    if (!items.length || items.length !== figs.length) return;
    for (var i = 0; i < items.length; i++) {
      items[i].insertAdjacentElement('afterend', figs[i]);
    }
    wrap.classList.add('is-accordion');
    wrap.dataset.balmisoAccordion = '1';

    /* The section cycles every five seconds. Fine as a side panel, wrong as an
       accordion opening itself. It stops its own timer on a tab click, so one
       synthetic click goes through their handler rather than into their scope. */
    var open = wrap.querySelector('.balmiso-ing__item.is-active') || items[0];
    if (open) open.click();
  }

  function ingToColumns(wrap) {
    if (wrap.dataset.balmisoAccordion !== '1') return;
    var panel = wrap.querySelector('.balmiso-ing__panel');
    var figs = wrap.querySelectorAll('.balmiso-ing__figure');
    for (var i = 0; i < figs.length; i++) panel.appendChild(figs[i]);
    wrap.classList.remove('is-accordion');
    delete wrap.dataset.balmisoAccordion;
  }

  function ingSync(root) {
    var wraps = (root || document).querySelectorAll(ING_WRAP);
    for (var i = 0; i < wraps.length; i++) {
      if (ingWantsAccordion(wraps[i])) ingToAccordion(wraps[i]);
      else ingToColumns(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ingSync(); });
  } else {
    ingSync();
  }

  var ingTimer = null;
  window.addEventListener('resize', function () {
    if (ingTimer) return;
    ingTimer = window.setTimeout(function () { ingTimer = null; ingSync(); }, 120);
  }, { passive: true });

  window.setTimeout(function () { ingSync(); }, 250);
  document.addEventListener('shopify:section:load', function (e) { ingSync(e.target); });
})();


/* ---------------------------------------------------------------------------
   PDP rails: mobile dots
   The media stack is a vertical column on desktop and a horizontal swipe on
   mobile. Only the mobile form needs dots, so everything here no-ops once the
   stack is not laying out in a row.
   --------------------------------------------------------------------------- */
(function () {
  function railsDots(root) {
    var dots = root.querySelector('[data-balmiso-rails-dots]');
    var stack = root.querySelector('.balmiso-rails__stack');
    if (!dots || !stack) return;

    var buttons = Array.prototype.slice.call(dots.querySelectorAll('.balmiso-rails__dot'));
    var frames = Array.prototype.slice.call(stack.querySelectorAll('.balmiso-rails__frame'));
    if (!buttons.length || buttons.length !== frames.length) return;

    function isCarousel() {
      return getComputedStyle(stack).flexDirection === 'row';
    }

    function mark(i) {
      buttons.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
    }

    var raf = null;
    stack.addEventListener('scroll', function () {
      if (raf || !isCarousel()) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var mid = stack.scrollLeft + stack.clientWidth / 2;
        var best = 0, bestGap = Infinity;
        frames.forEach(function (f, n) {
          var gap = Math.abs(f.offsetLeft + f.offsetWidth / 2 - mid);
          if (gap < bestGap) { bestGap = gap; best = n; }
        });
        mark(best);
      });
    }, { passive: true });

    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (!isCarousel()) return;
        stack.scrollTo({ left: frames[i].offsetLeft, behavior: 'smooth' });
        mark(i);
      });
    });
  }

  function init() {
    document.querySelectorAll('.balmiso-rails').forEach(railsDots);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();


/* ---------------------------------------------------------------------------
   Ingredients dialog
   Native <dialog>, so Escape, focus trapping and the backdrop come for free.
   Clicking the backdrop closes it: the dialog fills the top layer, so a click
   whose target is the dialog itself landed outside the panel.
   --------------------------------------------------------------------------- */
(function () {
  function init() {
    document.querySelectorAll('[data-balmiso-inci-open]').forEach(function (btn) {
      if (btn.dataset.balmisoInciBound) return;
      btn.dataset.balmisoInciBound = '1';
      btn.addEventListener('click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-balmiso-inci-open'));
        if (!dlg) return;
        if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
      });
    });
    document.querySelectorAll('dialog.balmiso-inci').forEach(function (dlg) {
      if (dlg.dataset.balmisoInciBound) return;
      dlg.dataset.balmisoInciBound = '1';
      // Close on any click outside the panel. Testing e.target === dlg catches
      // the backdrop, but a click on the dialog's own padding is not the
      // backdrop, so measure against the panel's box as well.
      dlg.addEventListener('click', function (e) {
        var panel = dlg.querySelector('.balmiso-inci__panel');
        if (!panel) { if (e.target === dlg) dlg.close(); return; }
        var r = panel.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right &&
                     e.clientY >= r.top  && e.clientY <= r.bottom;
        if (!inside) dlg.close();
      });
      var x = dlg.querySelector('[data-balmiso-inci-close]');
      if (x) x.addEventListener('click', function () { dlg.close(); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Hero video: mute and unmute.
   The hero renders a plain <video>, not the theme's <video-element>, so the
   vendor's volume script never sees it. Same two-icon button, wired here.
   Browsers refuse autoplay with sound, so the video always starts muted and
   this is the only route to hearing it. */
(function () {
  function bind(btn) {
    if (btn.dataset.bound) return;
    // closest() returns the NEAREST match, and a bare `div` in the old list
    // matched the button's own wrapper, which holds no video. The lookup came
    // back empty, bind returned early, and because the flag was set first the
    // button looked wired while tapping it did nothing at all. The section is
    // what owns both the video and the button, so look there.
    var host = btn.closest('.shopify-section') || btn.closest('.gsp-hero, section');
    var video = host && host.querySelector('video');
    if (!video) return;
    btn.dataset.bound = '1';
    var iconMuted = btn.querySelector('.icon-mute');    // speaker with a cross
    var iconSound = btn.querySelector('.icon-unmute');  // speaker with waves
    function paint() {
      // The icon shows the current STATE, as the theme's own players do: the
      // cross while silent, the waves while sound is on. This had it the other
      // way round, so the cross appeared exactly when the audio was playing.
      // The label names the action, which is the accessible convention.
      if (iconMuted) iconMuted.classList.toggle('hidden', !video.muted);
      if (iconSound) iconSound.classList.toggle('hidden', video.muted);
      btn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    }
    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      // Recorded so the autoplay retry above knows sound was asked for.
      if (video.muted) delete video.dataset.balmisoSound;
      else video.dataset.balmisoSound = '1';
      if (!video.muted && video.paused) video.play().catch(function () {});
      paint();
    });
    // Keep the icon honest if anything else changes the muted state.
    video.addEventListener('volumechange', paint);
    paint();
  }
  function scan() {
    document.querySelectorAll('[data-balmiso-hero-volume]').forEach(bind);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();

/* Mobile menu submenus are the vendor's own behaviour again.

   A custom opener used to live here because the submenu rows appeared to have
   no handler. The real cause was a duplicate `class` attribute in
   header__menu-mobile.liquid that discarded `gsp-menu-link-item`, the selector
   the vendor binds in GSP.headerMobile.activeSubmenu. With the attribute merged
   the vendor opener binds again and, crucially, removes the `inert` attribute
   the theme puts on every submenu at init - something the custom opener never
   did, which is why a reopened panel could not be scrolled or tapped. */

/* Videos play only while you are looking at them.

   The theme's players pause themselves once they are fully off screen
   (GSP.Motion.inView in VideoElement), but only at the last pixel, so a sliver
   left at the edge of the screen kept its audio going. The hero is a plain
   <video> and had no rule at all: once unmuted it looped with sound for the
   rest of the visit, wherever you scrolled.

   One rule for all of them now: a video plays while at least half of what can
   be seen of it is on screen, and pauses otherwise, or when the tab is hidden.
   Theme players are driven through their own API (paused flag, play, pause),
   the same idiom the theme uses in pauseOtherVideoOnPage, and setting `paused`
   also stops the theme's own inView from restarting them early.

   Positions are read on scroll rather than with IntersectionObserver so the
   rule is a plain function of where the page is, easy to check and to reason
   about; three getBoundingClientRect calls per 120ms of scrolling cost
   nothing. */
(function () {
  var SHOW = 0.5;

  function hosts() {
    var out = [].slice.call(document.querySelectorAll('video-element[autoplay]'));
    document.querySelectorAll('video.gsp-video').forEach(function (v) {
      if (v.closest('video-element')) return;
      // The hero no longer carries the autoplay attribute (see attach below),
      // so it is recognised by the marker the snippet writes instead.
      if (v.autoplay || v.hasAttribute('data-balmiso-autoplay')) out.push(v);
    });
    return out;
  }

  /* The hero used to ship its file with the page. `autoplay` overrides
     preload, so the browser began pulling it the moment the page opened, even
     with the hero several screens down: measured, 14 of its 32 seconds (about
     35MB of the original) were buffered before it was ever scrolled to.

     Now the page carries no source and no poster for it, only data-src and
     data-poster, so it costs nothing at load. It is given them once it is
     within a screen of coming into view, which leaves that screen of scrolling
     for the first seconds to buffer before it is actually seen. The file itself
     is untouched: same original, same quality. */
  function near(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh * 2 && r.bottom > -vh;
  }

  function attach(v) {
    if (!v.hasAttribute('data-balmiso-lazy')) return;
    v.removeAttribute('data-balmiso-lazy');
    var poster = v.getAttribute('data-poster');
    if (poster) v.setAttribute('poster', poster);
    v.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    });
    v.preload = 'auto';
    v.load();
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!r.width || !r.height) return false;
    var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    if (seen <= 0) return false;
    // Against whichever is shorter, the video or the screen, so a video taller
    // than a phone can still count as fully in view.
    return seen / Math.min(r.height, vh) >= SHOW;
  }

  function nativeOf(el) {
    return el.tagName === 'VIDEO' ? el : el.querySelector('video');
  }

  function start(el) {
    if (el.tagName === 'VIDEO-ELEMENT') {
      el.paused = false;
      el.play();
    }
    var v = nativeOf(el);
    if (!v || !v.paused) return;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {
      // Sound was on, and this browser will not resume audibly without a fresh
      // tap. Fall back to playing silently rather than to a frozen frame; the
      // hero's icon follows through volumechange.
      if (el === v && !v.muted) {
        v.muted = true;
        delete v.dataset.balmisoSound;
        v.play().catch(function () {});
      }
    });
  }

  function stop(el) {
    if (el.tagName === 'VIDEO-ELEMENT') {
      el.paused = true;
      el.pause();
    }
    // Directly as well: the theme's pause() is skipped when its `playing`
    // attribute is out of date, and an off-screen video must never keep going.
    var v = nativeOf(el);
    if (v && !v.paused) v.pause();
  }

  function check() {
    var hidden = document.visibilityState === 'hidden';
    hosts().forEach(function (el) {
      if (el.tagName === 'VIDEO' && !hidden && near(el)) attach(el);
      var show = !hidden && onScreen(el);
      var was = el.dataset.balmisoInView === '1';
      el.dataset.balmisoInView = show ? '1' : '0';
      if (show && !was) start(el);
      else if (!show) stop(el);
    });
  }

  var timer = null;
  function soon() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; check(); }, 120);
  }

  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon);
  window.addEventListener('load', check);
  document.addEventListener('visibilitychange', check);
  document.addEventListener('shopify:section:load', soon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();

/* Waitlist popup: any link to #waitlist opens it. Shopify posts the form and
   reloads the page with #BalmisoWaitlistForm, so reopen it there to show the
   thank-you or the error. Other customer forms (footer newsletter) share
   form.posted_successfully?, hence the hash check. */
(function () {
  var dlg = document.getElementById('BalmisoWaitlist');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var fields = dlg.querySelector('[data-balmiso-waitlist-fields]');
  var done = dlg.querySelector('[data-balmiso-waitlist-done]');
  var error = dlg.querySelector('[data-balmiso-waitlist-error]');
  var ours = location.hash === '#BalmisoWaitlistForm';
  // A product card's button names its product, so the signup is tagged with
  // that product rather than the page it was on. Anything else keeps the
  // page's own tags.
  var tagsInput = dlg.querySelector('input[name="contact[tags]"]');
  var pageTags = tagsInput ? tagsInput.value : '';
  var lastProduct = null;

  function tagFor(a) {
    var handle = a.getAttribute('data-waitlist-product');
    if (tagsInput) tagsInput.value = handle ? 'waitlist, waitlist-' + handle : pageTags;
    // Joining for one product should not hide the form for the next one
    if (handle && handle !== lastProduct && !done.hidden) {
      done.hidden = true;
      fields.hidden = false;
      dlg.classList.remove('is-done');
    }
    lastProduct = handle;
  }

  function open() {
    // show(), not showModal(): see the note in balmiso-brand.css.liquid. A modal
    // dialog blocks hCaptcha's challenge, which Shopify requires before it
    // accepts the signup.
    if (!dlg.open) {
      dlg.show();
      document.documentElement.style.overflow = 'hidden';
    }
    var target = done.hidden ? fields.querySelector('input[type="email"]') : done.querySelector('[data-balmiso-waitlist-done-title]');
    if (target) target.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#waitlist"], a[href$="/#waitlist"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    tagFor(a);
    document.dispatchEvent(new CustomEvent('balmiso:waitlist', { detail: { source: a } }));
    open();
  }, true);

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-balmiso-waitlist-close]')) dlg.close();
  });

  // a non-modal dialog does not close itself on Escape, and does not lock the
  // page behind it, so both are done here
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dlg.open) dlg.close();
  });
  dlg.addEventListener('close', function () {
    document.documentElement.style.overflow = '';
  });

  function showDone() {
    fields.hidden = true;
    done.hidden = false;
    dlg.classList.add('is-done');
    document.dispatchEvent(new CustomEvent('balmiso:waitlist-joined'));
    var title = done.querySelector('[data-balmiso-waitlist-done-title]');
    if (title && dlg.open) title.focus({ preventScroll: true });
  }

  function showError(html) {
    var box = fields.querySelector('[data-balmiso-waitlist-error]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'balmiso-waitlist__error';
      box.setAttribute('role', 'alert');
      box.setAttribute('data-balmiso-waitlist-error', '');
      fields.querySelector('.balmiso-waitlist__row').after(box);
    }
    box.innerHTML = html;
    box.hidden = false;
  }

  // The signup posts the form itself, the ordinary way. Shopify's hCaptcha
  // protection binds to this form and adds its token on a real submit; a
  // background fetch skips that binding, so the store answered every signup
  // with "Missing CAPTCHA token" and nobody was recorded. Shopify reloads the
  // page with #BalmisoWaitlistForm afterwards, and the block below reopens the
  // popup on the thank-you or the error.
  var form = dlg.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      var button = form.querySelector('[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.busyLabel || button.textContent;
      }
      // Shopify's hCaptcha script takes the submit over, asks for a token and
      // posts the form itself. Nothing here posts the form without that token:
      // Shopify answers a tokenless post with a hard "Missing CAPTCHA token"
      // error page, which is exactly what visitors were seeing before.
    });
  }

  if (!ours) {
    if (error) error.hidden = true;
    return;
  }
  if (done.dataset.posted === 'true') showDone();
  open();
  var q = location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, '');
  history.replaceState(null, '', location.pathname + q);
})();

/* Ritual pages that have no products yet: the hero button says "Be the first
   to know", so it must open the waitlist rather than scroll to a grid that is
   not there. The coming soon card is the marker for an empty ritual. */
(function () {
  if (!document.querySelector('.balmiso-soon')) return;
  document.querySelectorAll('[id$="__hero"] a[href="#shop"]').forEach(function (a) {
    a.setAttribute('href', '#waitlist');
  });
})();
